import { SIDANG_TYPE } from "./SidangType.constants";

const DeadlineSubmisi = {
  jenisSidang: SIDANG_TYPE,
  jenisBerkas: {
    "Softcopy Berkas": "Softcopy Berkas",
    PPT: "PPT",
    "Berkas Pendukung": "Berkas Pendukung",
  },
  jenisSubmisi: {
    "Berkas Maju Sidang": "Berkas Maju Sidang",
    "Berkas Final": "Berkas Final",
  },
};

export { DeadlineSubmisi };
